import { render } from "./suivi_list_page.vue?vue&type=template&id=1c80e2fc"
import script from "./suivi_list_page.vue?vue&type=script&lang=js"
export * from "./suivi_list_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__